import React, { useContext } from "react";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { AppContext } from "../RoundRegContext";
import PreviewModalCard from "./PreviewModalCard";
import { useTranslation } from "react-i18next";

const PreviewModal = ({ questionPreModal, setQuestionPreModal }) => {
	const { t } = useTranslation();
	const { qList, roundRegForm } = useContext(AppContext);

	const roundName = roundRegForm.watch().roundTitle || "";

	return (
		<ModalTemplate
			modalState={questionPreModal}
			setModalToggle={setQuestionPreModal}
			title={t("pages.round.RoundReg.Question.PreviewModal.question-title")}
			width={1100}
			className="question-preview-modal"
		>
			<div className="modal-content">
				<div className="faq-preview-bg">
					<div className="faq-preview-title">
						<dt>{t("pages.round.RoundReg.Question.PreviewModal.dt")}</dt>
						<dd>{roundName}</dd>
					</div>
				</div>
				<ul className="faq-list">
					{qList.map((d, idx) => (
						<PreviewModalCard key={idx} question={d} />
					))}
				</ul>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => setQuestionPreModal(false)}
				>
					{t("pages.round.RoundReg.Question.PreviewModal.confirm")}
				</button>
			</div>
		</ModalTemplate>
	);
};

export default PreviewModal;
